import { atom } from "jotai";

export const supplierOrderItems = atom([]);